import React, { useCallback, useState } from 'react';
import { TextFieldProps } from 'mui-rff';
import { amountFormatter, parseAmount } from 'utils/formatters';
import Input from '../Input';

type AmountInputProps = TextFieldProps & {
  currency?: string;
};

const AmountInput = ({ currency, onBlur, ...props }: AmountInputProps) => {
  const [focused, setFocused] = useState(false);

  const handleOnFocus = () => {
    setFocused(true);
  };

  const handleOnBlur = (event: React.FocusEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    if (onBlur) onBlur(event);
    setFocused(false);
  };

  // eslint-disable-next-line react-hooks/exhaustive-deps
  const formatAmount = useCallback(amountFormatter(currency || 'GHS', focused), [currency, focused]);

  return (
    <Input
      InputProps={{
        disableUnderline: true,
      }}
      fieldProps={{ format: formatAmount, parse: parseAmount }}
      onFocus={handleOnFocus}
      onBlur={handleOnBlur}
      {...props}
    />
  );
};

export default AmountInput;
